const ComingSoon = ({ title, message }) => {
  return (
    <main className="coming-soon">
      <h1>{title}</h1>
      <p>{message}</p>
    </main>
  );
};

export default ComingSoon;
